import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, Home, MessageCircle } from "lucide-react";
import { fetchYesteryearBookingBySession } from "@/lib/api";

export default function YesteryearBookingSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let attempts = 0;
    const poll = async () => {
      if (!sessionId) return setLoading(false);
      try {
        const b = await fetchYesteryearBookingBySession(sessionId);
        setBooking(b);
        if (b?.payment_status === "paid" || attempts >= 6) {
          setLoading(false);
          return;
        }
      } catch (err) {
        if (attempts >= 6) return setLoading(false);
      }
      attempts += 1;
      setTimeout(poll, 1500);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-24" data-testid="yy-success-page">
      <div className="card-warm rounded-2xl p-10 text-center">
        {loading ? (
          <>
            <Loader2 className="animate-spin mx-auto text-[#6E2638]" size={40} />
            <p className="mt-4 text-[#1A1817]/70">Confirming your booking…</p>
          </>
        ) : booking?.payment_status === "paid" ? (
          <>
            <CheckCircle2 className="mx-auto text-[#1E4637]" size={48} />
            <h1 className="serif text-4xl text-[#6E2638] mt-4">Yesteryear Talk confirmed!</h1>
            <p className="mt-3 text-[#1A1817]/85 text-lg">
              Thank you, {booking.contact_name}. Martin will call within 24 hours to lock in the
              date for <b>{booking.venue_name}</b>.
            </p>
            <div className="mt-6 inline-block rounded-xl bg-[#F5EFEB] border border-[#E5D9C5] px-6 py-4 text-left">
              <div className="text-xs uppercase tracking-[0.2em] text-[#1E4637]">Session</div>
              <div className="serif text-[#6E2638] text-xl">{booking.option_label}</div>
              <div className="text-sm text-[#1A1817]/70 mt-1">
                Preferred date: <b>{booking.preferred_date || "TBC"}</b> · Audience: <b>{booking.audience_size || "TBC"}</b>
              </div>
              <div className="text-sm text-[#1A1817]/70 mt-1">
                Paid: <b>AUD ${booking.total_price_aud.toFixed(2)}</b>
              </div>
            </div>
            <p className="text-xs text-[#1A1817]/60 mt-4 italic">
              Confirmation email sent to {booking.contact_email}.
            </p>
          </>
        ) : (
          <>
            <MessageCircle className="mx-auto text-[#6E2638]" size={48} />
            <h1 className="serif text-4xl text-[#6E2638] mt-4">Booking received</h1>
            <p className="mt-3 text-[#1A1817]/85">
              Payment is still processing — you'll get a confirmation email shortly. If anything
              looks off, drop Martin a line at Mmmwt35@gmail.com.
            </p>
          </>
        )}

        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link to="/" className="btn-primary" data-testid="yy-success-home">
            <Home size={16} /> Back to home
          </Link>
          <Link to="/yesteryear" className="btn-outline-gold" data-testid="yy-success-more">
            Book another session
          </Link>
        </div>
      </div>
    </div>
  );
}
